@if (uploadProgressService.currentProgress() > 0) {
  <div class="message account-message">
    <div class="message-icon">
      <img
        class="message-icon-img"
        [src]="getImage()"
        alt=""
      >
    </div>
    <div class="message-content">
    <span class="message-sender">
      {{ selectedAccount.accountName }}
    </span>
      <div class="message-text">
        <div class="skeleton-loader message-video">
          <app-telegram-upload-status/>
        </div>
      </div>
    </div>
  </div>
}
